import React from "react";
import { Box, Checkbox, FormControlLabel, Typography } from "@mui/material";

// visibilities whose auctions can take requests to participate: a bidder
// who can see the auction but is not in it may ask to join
export const JOIN_REQUEST_VISIBILITIES = [
  "PUBLIC_AUCTION",
  "SELLER_BIDDERS_ONLY_AUCTION",
];

// The Rules screens' "Allow bidders to request to participate" setting.
// Hidden for Participants only auctions, which nobody else can see. With
// `status` "ended" it says why bidders can't ask now.
const JoinRequestsSetting = ({ visibility, checked, onChange, disabled, status }) => {
  if (!JOIN_REQUEST_VISIBILITIES.includes(visibility)) return null;
  return (
    <Box
      sx={{
        border: "1px solid #D5DAE5",
        backgroundColor: "#F8F9FC",
        p: 2,
        my: 2,
        maxWidth: 720,
      }}
    >
      <FormControlLabel
        control={
          <Checkbox
            checked={Boolean(checked)}
            onChange={(event) => onChange(event.target.checked)}
            disabled={disabled}
            name="allowJoinRequests"
          />
        }
        label={
          <Typography sx={{ fontWeight: 600 }}>
            Allow bidders to request to participate
          </Typography>
        }
      />
      <Typography variant="body2" sx={{ color: "#4B5563", ml: 4 }}>
        Bidders who find this auction can ask to join. You approve each one and
        choose their lots, in the auction's Requests tab.
      </Typography>
      {checked && status === "ended" && (
        <Typography variant="body2" sx={{ color: "#8A2412", ml: 4, mt: 1 }}>
          This auction has ended, so bidders can't request to participate now.
        </Typography>
      )}
    </Box>
  );
};

export default JoinRequestsSetting;
